import type { AxleListResponse } from '@contracts/axle/AxleListResponse';
import { VehicleAxlesList } from '@src/axles/domain/VehicleAxlesList';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';

export const AxleClient = {
  list: async (clientId: string) => {
    const { data: response } = await AuthenticatedClient.get<AxleListResponse>(
      `clients/${clientId}/axles`,
    );

    return new VehicleAxlesList({
      trailersAxles: response.trailerAxles,
      tractorsAxles: response.tractorAxles,
    });
  },
};
